import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import { useSelector } from 'store/hooks';
import DonutCard from 'components/DashboardComponents/DashboardGraphs/DonutChartDashboard';
import DashboardListTable from 'components/DashboardComponents/DashboardListTable/DashboardListTable';
import PendingAtBarChart from 'components/DashboardComponents/DashboardGraphs/PendingAtBarChart';
import KpiMetricsTable from './KpiMetricsTable/KpiMetricsTable';

const KpiMetricsAcceptance = ({
  donutDataClient,
  COLORS_CONSULTANT,
  COLORS_DM,
  COLORS_CLIENT,
  barChartData,
  metric,
  data_table,
  onDownloadXlsx,
  showDownload,
}) => {
  const { loadings } = useSelector((state) => state);
  const workFlowLabels = [
    { labelname: 'Accepted', color: '#61D2A4', dataKey: 'accepted', toolbarText: 'acceptedRaw' },
    {
      labelname: 'Accepted with reservation',
      color: '#3B82F6',
      dataKey: 'acceptedWithReservation',
      toolbarText: 'acceptedWithReservationRaw',
    },
    { labelname: 'REFUSED', color: '#FF6040', dataKey: 'rejected', toolbarText: 'rejectedRaw' },
    {
      labelname: 'To be Done',
      color: '#FFC107',
      dataKey: 'toBeDone',
      toolbarText: 'toBeDoneRaw',
    },
  ];

  return (
    <>
      {/* Donut Chart Row */}
      <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
        {[{ title: 'Acceptance', data: donutDataClient, colors: COLORS_CLIENT }].map((item) => (
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={6}>
                <Paper
                  sx={{
                    height: '100%',
                    flexGrow: 1,
                    flexBasis: 0,
                    borderRadius: 2,
                    p: { xs: 1.5, sm: 2, md: 2 },
                    boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <DonutCard
                    title={item.title}
                    data={Object.entries(item?.data ?? {}).map(([name, value]) => ({ name, value }))}
                    colors={item.colors}
                    chartHeight={180}
                  />
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <DashboardListTable
                  data={Object.entries(item?.data ?? {})
                    .map(([name, value]) => {
                      const cleanedName = name.replace(/client/gi, '').trim();
                      const formattedName = cleanedName
                        ? cleanedName.charAt(0).toUpperCase() + cleanedName.slice(1).toLowerCase()
                        : cleanedName;

                      return { name: formattedName, value };
                    })
                    .sort((a, b) => a.name.localeCompare(b.name))}
                  metric={metric}
                />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      {/* Pending at Bar Chart */}
      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
              borderRadius: 2,
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
            }}
          >
            <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 600, mb: 1 }}>
              Acceptance
            </Typography>
            <PendingAtBarChart data={barChartData} height={250} baseLabels={workFlowLabels} />
          </Paper>
        </Grid>
      </Grid>
      {/* Table Row */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, borderRadius: 3 }}>
            {/* <KpiMetricsTable FilterKpiMetric={metric} dashboardKpiGridData={[]} FilterNeeded={false} /> */}
            <KpiMetricsTable
              FilterKpiMetric={metric}
              dashboardKpiGridData={data_table}
              FilterNeeded={false}
              isLoading={Boolean(loadings?.dashboardKpiGrid)}
              onDownloadXlsx={onDownloadXlsx}
              showDownload={showDownload}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiMetricsAcceptance;
